var _rect, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAustria(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 900,
    height: 600,
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#ed2939",
    width: 900,
    height: 600
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    y: 200,
    width: 900,
    height: 200
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAustria);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5MDAiIGhlaWdodD0iNjAwIj4KPHJlY3QgZmlsbD0iI2VkMjkzOSIgd2lkdGg9IjkwMCIgaGVpZ2h0PSI2MDAiLz4KPHJlY3QgZmlsbD0iI2ZmZiIgeT0iMjAwIiB3aWR0aD0iOTAwIiBoZWlnaHQ9IjIwMCIvPgo8L3N2Zz4=";
export { ForwardRef as ReactComponent };